<template>
  <div
    class="quick-add"
    :class="[{ 'quick-add--sizes-shown': sizesAreShown }, modifier ? `quick-add--${modifier}` : '']"
    @mouseleave="hideModals"
  >
    <div
      class="quick-add__position-absolute-container"
      :class="{ 'quick-add__position-absolute-container--sizes-shown': sizesAreShown }"
    >
      <Sizes
        :variant="variant"
        :slug="variant.spreeProduct.groupSlug"
        :variantSkus="variant.skus || []"
        :isVariantSock="isVariantSock"
        :gender="isUnisex ? GENDERS.unisex : variant.gender[0]"
        :sizeFinderButtonState="sizeFinderButtonState"
        :imageUrl="imageUrl"
        :isBackorderable="!!variant.isBackorderable"
        :productName="productName"
        :isInsideQuickAdd="true"
        :isInsideQuickView="false"
        @select-size="handleSelectSize"
        v-data-test-id="'sizes'"
      />
    </div>
    <QuickAddButton
      class="quick-add__button"
      :sizesAreShown="sizesAreShown"
      :buttonText="buttonText"
      :modifier="modifier"
      @click.native.prevent="showSizes"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { GENDERS } from '@/stores/product'
import getPageContext from '@/helpers/page-context'
import updateCartMixin from '@/mixins/update-cart'
import Sizes from '@/components/_shared/Sizes/Sizes.vue'
import QuickAddButton from '@/components/_shared/QuickAdd/QuickAddButton.vue'

export default {
  name: 'QuickAdd',
  components: { Sizes, QuickAddButton },
  mixins: [updateCartMixin],

  props: {
    variant: { type: Object, required: true },
    onSizesPanelChange: { type: Function, default: () => {} },
    buttonText: { type: String, default: '' },
    modifier: { type: String, default: '' },
  },

  data() {
    return {
      sizesAreShown: false,
      GENDERS,
    }
  },

  computed: {
    isVariantSock() {
      if (!this.variant.spreeProduct) return false
      return this.variant.spreeProduct.groupName.match(/Sock/) ? true : false
    },
    imageUrl() {
      if (!this.spreeProduct) return ''
      return this.variant.imageUrl
    },

    productName() {
      if (!this.spreeProduct) return ''
      return this.variant.spreeProduct.groupName
    },

    spreeProduct() {
      return this.variant.spreeProduct
    },

    sizeFinderButtonState() {
      return {
        isInactive: false,
        onClick: ($event, selectedSku) =>
          this.handleSizeFinderClick($event, selectedSku, this.updateCart),
        text: this.$t('size_guide.size_finder.add'),
      }
    },

    isUnisex() {
      return this.variant.gender.length > 1
    },
  },

  watch: {
    sizesAreShown() {
      this.onSizesPanelChange(this.sizesAreShown)
    },
  },

  methods: {
    ...mapActions({
      hideSizeGuideOverlay: 'overlay/hideSizeGuideOverlay',
      showOutOfStockOverlay: 'overlay/showOutOfStockOverlay',
    }),

    hideModals() {
      this.sizesAreShown = false
    },

    showSizes() {
      this.sizesAreShown = true
    },

    handleSelectSize(selectedSize, $event) {
      const selectedSku = this.variant.skus.find(sku => sku.size === selectedSize?.size)
      if ($event) this.updateCart(selectedSku, getPageContext($event))

      this.$emit('select-size', selectedSize)
    },

    handleSizeFinderClick($event, selectedSku, action) {
      this.hideSizeGuideOverlay()
      if (selectedSku.stock) {
        action(selectedSku, getPageContext($event))
      } else {
        this.showOutOfStockOverlay({
          sku: selectedSku.sku,
          size: selectedSku.size,
          slug: this.variant.spreeProduct.groupSlug,
          imageUrl: this.imageUrl,
          isBackorderable: !!this.variant.isBackorderable,
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import './QuickAdd';
</style>
